/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Green_Wild_Ant_SingInputs */

const en_green_wild_ant_sing = /** @type {(inputs: Green_Wild_Ant_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kultify admins only`)
};

const de_green_wild_ant_sing = /** @type {(inputs: Green_Wild_Ant_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur für Kultify-Admins`)
};

/**
* | output |
* | --- |
* | "Kultify admins only" |
*
* @param {Green_Wild_Ant_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const green_wild_ant_sing = /** @type {((inputs?: Green_Wild_Ant_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Green_Wild_Ant_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_green_wild_ant_sing(inputs)
	return de_green_wild_ant_sing(inputs)
});